import { motion } from "framer-motion";
import { ArrowUpRight, Compass, Users, Repeat, Target, Workflow, Presentation, RotateCcw, Flag } from "lucide-react";
import { Reveal } from "./Reveal";

const ICONS = [Compass, Users, Repeat, Target, Workflow, Presentation, RotateCcw, Flag];

export const Services = ({ t }) => (
  <section id="services" className="py-24 md:py-32 lg:py-40 border-t border-line" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="mb-16 md:mb-20">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-accent mb-6">{t.services.eyebrow}</p>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.02] max-w-3xl">
            {t.services.title}
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 border-t border-l border-line">
        {t.services.items.map(([num, title, desc], i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
          <motion.div
            key={num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.06 }}
            className="group relative border-r border-b border-line p-8 md:p-9 min-h-[260px] flex flex-col bg-bone hover:bg-secondary/60 transition-colors duration-500"
            data-testid={`service-${num}`}
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-sm font-semibold text-accent">{num}</span>
              <ArrowUpRight size={18} className="text-line group-hover:text-green transition-colors duration-300" />
            </div>
            <Icon size={30} strokeWidth={1.25} className="text-green mt-7 group-hover:text-accent transition-colors duration-300" data-testid={`service-icon-${num}`} />
            <h3 className="font-display font-medium text-xl md:text-2xl text-ink mt-5 leading-tight">{title}</h3>
            <p className="text-sm text-ink-2 leading-relaxed mt-3">{desc}</p>
            <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-accent group-hover:w-full transition-all duration-500" />
          </motion.div>
        );})}
      </div>
    </div>
  </section>
);
